import type { ReactNode } from 'react'

import { ModalInput, type TModalInputProps } from '@/src/elements/input/ModalInput/ModalInput'

import { SettingsProfileButton, type TSettingsProfileButtonProps } from '../SettingsProfileButton/SettingsProfileButton'

type TSettingsProfileInputProps = TSettingsProfileButtonProps &
  Omit<TModalInputProps, 'renderTrigger'> & {
    triggerButtonTestID?: string
  }

export const SettingsProfileInput = ({
  isLoading,
  label,
  placeholder,
  value,
  title = label,
  onCancel,
  testID,
  triggerButtonTestID,
  ...modalProps
}: TSettingsProfileInputProps): ReactNode => (
  <ModalInput
    testID={testID}
    onCancel={onCancel}
    renderTrigger={({ onTrigger }) => (
      <SettingsProfileButton
        testID={triggerButtonTestID}
        onPress={onTrigger}
        isLoading={isLoading}
        label={label}
        placeholder={placeholder}
        value={value}
      />
    )}
    title={title}
    {...modalProps}
  />
)
